(() => {
  const HIDDEN_CLASS = 'klaviyo-teaser-is-hidden';
  const SCROLLING_CLASS = 'klaviyo-teaser-scrolling';
  const IDLE_MS = 1000;

  let idleTimer = null;

  function teaserRoots() {
    return Array.from(document.querySelectorAll('[data-testid="animated-teaser"]')).map((teaser) => {
      let node = teaser.parentElement;
      let root = teaser;

      while (node && node !== document.body) {
        const position = window.getComputedStyle(node).position;
        if (position === 'fixed') {
          root = node;
          break;
        }
        node = node.parentElement;
      }

      return root;
    });
  }

  function setHidden(hidden) {
    document.documentElement.classList.toggle(SCROLLING_CLASS, hidden);

    teaserRoots().forEach((root) => {
      root.classList.toggle(HIDDEN_CLASS, hidden);
    });
  }

  function onScroll() {
    setHidden(true);

    if (idleTimer) {
      window.clearTimeout(idleTimer);
    }

    idleTimer = window.setTimeout(() => {
      setHidden(false);
      idleTimer = null;
    }, IDLE_MS);
  }

  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
})();
